export default __webpack_public_path__ + "static/media/why-choose-us.efe76b10.webp";